module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPf394SEhCmcOjqUOlqMKTGUMVJaEEJCGTpCGTo6GTE6GTE6CCkxECExECExCCEpEBkpCBkhEAghCBAZCAgZCDoAADEAAAgICCEAABkAABAAAAAAAP///wAAAAAAAAAAACH5BAEHABwALAAAAAAgACAAAAW7ICeOZGmeaKqubOu+cCzPcxDQq+1ufO//QOAIsDEQBEgBZWPB9CqWTC9J5WxEGwp1qaR4kd6voEFFYq3babn82EzKI15avqZGNoy6cjPn65EIPHlrXElLUn+AgnWFYBsafn8KPAeMkXt0fxCUln2JAgyLhJcUTpd1CxsPawV7ZQmZSANlS1pVWFlbWhQTD6sCEA4PthJrIhdYtoY+Xj0WE8pVyCRhzUE/1WFXNDo4J93e4eLj5OXm5+gcIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadE2_S1.gif
// module id = alev
// module chunks = 50